import React from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

import Button from 'carbon-react/lib/components/button';

import styles from './bottom-controls.scss';

interface BottomControlsProps {
  addSpacer?: boolean;
  className?: string;
  onEnd?: () => void;
  style?: React.CSSProperties;
}

export const BottomControls = ({ addSpacer = false, className, onEnd, style = {} }: BottomControlsProps) => (
  <>
    <div className={clsx(styles.container, className)} style={style}>
      <Button buttonType='primary' onClick={onEnd} className={styles.button}>
        <FormattedMessage id="onboarding.end_guided_flow" defaultMessage="End guided flow" />
      </Button>
    </div>
    {addSpacer && <div className={styles.spacer} />}
  </>
);
